import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { CommonUtil } from '../../../core/Utils/common-util';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { ActivatedRoute, Router, Event as NavigationEvent } from '@angular/router';
import { FacilityService } from '../../../core/services/facility.service';
import { FacilityDetailsService } from '../../services/facility-details.service';
import { FacilityObject, FacilitySummaryObject } from '../../../core/services/facility.model';
import { Subscription } from 'rxjs';
import { InvitedFacility, MultiFacilityModel } from '../../services/multi-facility.model';
import { MultiFacilityService } from '../../services/multi-facility.service';
import { Location } from '@angular/common';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-manage-facilities',
  templateUrl: './manage-facilities.component.html',
  styleUrls: ['./manage-facilities.component.scss'],
})
export class ManageFacilitiesComponent implements OnInit, AfterViewChecked {
  private sub = new Subscription(); 
  currentFacility: FacilityObject;
  rootScopeData: RootScopeDeclare;
  userPermission: boolean = true;
  active: Number = 1;
  allFacMap = new Map<String, FacilitySummaryObject>();
  manageFacilityHint: boolean = false;
  hintMsg: string;
  allFacList: MultiFacilityModel[] = new Array();
  allFacilitiesCount: Number = 0;
  byRequester: boolean;

  pendingFacilities: InvitedFacility[] = [];
  requestedFacilities: InvitedFacility[] = [];
  pendingRequests: InvitedFacility[] = [];

  constructor(
    private rootScopeService: RootScopeService,
    private _facilityService: FacilityService,
    private _facilityDetailsService: FacilityDetailsService,
    private _route: ActivatedRoute,
    private _router: Router,
    private commonUtil: CommonUtil,
    private multiFacService: MultiFacilityService,
    private _location: Location,
    private loader: HaloLoaderService
  ) {}

  getRootScopeData(): void {
    const rootScopeSub = this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
      if (
        rootScopeData.managerData.isAdminAnyFacility === 'true' ||
        rootScopeData.managerData.isOwnerAnyFacility === 'true'
      )
        this.hintMsg = 'MANAGE.FACILITIES.HINT.MSG';
      else this.hintMsg = 'MANAGE.FACILITIES.NONADMIN.HINT.MSG';
    });
    this.sub.add(rootScopeSub);
  }

  ngOnInit(): void {
    this.getRootScopeData();
    this.setPageName();

    // subscribe facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    const facilityOnChangeSub = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
    });
    this.sub.add(facilityOnChangeSub);

    const setLevelUpdatedOnChangeSub = this.multiFacService.setLevelUpdated$.subscribe( res => {
      this.multiFacService.resetMultiFacilitiesList();
      this.getFacilitiesData();
    })
    this.sub.add(setLevelUpdatedOnChangeSub);

    this.getFacilitiesData();
    this.commonUtil.scrollTop();
    //need to change the above line once the all facilities service is ready

    /// Get pending facilities
    const pendingFacilitiesSub = this.multiFacService.invitedFacilities$.subscribe(
      (res) => {
        this.pendingRequests = [];
        this.pendingFacilities = [];
        if (res?.inviteFacilityRequestWrapper?.length > 0) {
          let requests: InvitedFacility[] = res.inviteFacilityRequestWrapper;
          requests.forEach( req => {
            if (req.approverEmail == this.rootScopeData.currentUser.emailAddress) {
              this.pendingRequests.push(req);
            } else {
              this.pendingFacilities.push(req);
            }
          });
        }
      },
      (err) => console.log(err)
    );
    this.sub.add(pendingFacilitiesSub);
    this.multiFacService.invitedFacilities();

    // Manage active route
    const activeTabSub = this._route.data.subscribe((data) => {
      let action = data['action'];
      switch (action) {
        case 'pending':
          this.navigateToChild(2, true);
          break;
        case 'manage':
          this.navigateToChild(3, true);
          break;
      }
    });
    this.sub.add(activeTabSub);

    const delinkFacilitySub = this._facilityService.delinkFacilitySubscriber.subscribe(val => {
      this._facilityService.deleteFacility(val.facilityId,val.childFacilityId,'delink');
      this.multiFacService.resetMultiFacilitiesDetails();
      this.getFacilitiesData();
    })
    this.sub.add(delinkFacilitySub);
  }

  ngAfterViewChecked() {
    if (this.multiFacService.highlightNode) {
      let id: string = 'main-38' + this.multiFacService.highlightNode + '297';
      const elmnt = document.getElementById(id) as HTMLElement;
      if (elmnt && elmnt.scrollIntoView) {
        elmnt.scrollIntoView({ behavior: 'smooth' });
      }
      this.multiFacService.highlightNode = '';
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();

  }

  setPageName(): void {
    this.rootScopeData.pageName = 'Facility - Manage';
  }

  navigateToChild(num: Number, isFromActiveNav: boolean = false) {
    this.active = num;

    // Navigating based on the tab.
    switch (num) {
      case 1:
        this._location.replaceState('/facility/manage');
        break;
      case 2:
        if (!isFromActiveNav) this._location.replaceState('/facility/manage/pending-request');
        break;
      case 3:
        if (!isFromActiveNav) this._location.replaceState('/facility/manage/manage-request');
        break;
    }
  }

  getFacilitiesData(): void {
    //need to fetch pending and all facilities data
    if (this.currentFacility.facilityId) {
      //need to check on how to get managefacilityhint for showing hint message
      this.allFacilitiesCount = 0;
      this.loader.startProcess();
      this.multiFacService
        .getMultiFacilities()
        .then(
          (res: MultiFacilityModel[]) => {
            this.allFacList = res;
            this.allFacilitiesCount = this.multiFacService.getAllFacilitiesLength();
            if (res[0] && res[0].children.length > 0) {
            }
            this.manageFacilityHint = this.multiFacService.manageFacilityHint;
          },
          (err) => {
            console.log(err);
          }
        )
        .finally(() => {
          this.loader.endProcess();
        });
    }
  }

  goToFacility(path: string[]): void {
    this._router.navigate([`facility/manage/${path}`]);
  }

  onCloseHint(): void {
    this.manageFacilityHint = false;
    const inputJson: any = {};
    inputJson.manageFacilityHint = 'false';
    this._facilityDetailsService.saveUserPreference(inputJson).subscribe((data: any) => {
      this.multiFacService.manageFacilityHint = false;
      this._facilityService.setManageFacilityHint(inputJson.manageFacilityHint)
    });
  }
  modifyManageRequestCount(count: number) {
    this.pendingRequests.length = count;
  }

  async saveFacilityUserPreference() {
    this.loader.startProcess();
    try {
      this.rootScopeData.showFacilitySetupPopup = false;
      await this._facilityService.updatedFacilityPreferenceForUser2({showFacilitySetupPopup:false});
    } catch (error) {
      console.error('API failed.');
    }
    this.loader.endProcess();
  }
}
